import { Component, Input } from "@angular/core";
import { INavigationItem } from "src/app/service/navigation.service";

@Component({
  selector: "app-top-level-navigation",
  templateUrl: "./top-level-navigation.component.html",
  styleUrls: ["./top-level-navigation.component.less"],
})
export class TopLevelNavigationComponent {
  @Input() items: INavigationItem[];
  @Input() navLength: number;

  navItems: INavigationItem[] = [];

  setNavItems() {
    if (this.navLength) {
      this.prepareNavItems(this.items);
    } else {
      this.navItems = this.items;
    }

    return true;
  }

  prepareNavItems(items) {
    const itemsQty = items.length;
    const itemsLength = items.map((e) => e.title).join('').length;

    if (itemsLength >= this.navLength) {
      const slicedItems = items.slice(0, itemsQty - 1);
      this.prepareNavItems(slicedItems);
    } else {
      this.navItems = items;
    }
  }
}
